const hubspotFormIds = Object.freeze({
  CONTACT_FORM: '75067fb5-da03-4e83-a699-48d2d49dc0a4',
  ACTIVATE_FORM: '02900e4d-c6eb-4056-b5a1-e98dc24949e3',
  NEWSLETTER_FORM: '5ef53b20-ddbe-4356-b7ba-347d47ea50e3',
  ELSUMMERDOWNLOAD: '70030e9a-06b9-4cbd-b67a-c4ff760d39aa',
  NEVER_MISS_WORKSHOP_FORM: '15bedc5c-ad52-4b38-98c0-d9ffb4e0819d',
})

export default hubspotFormIds
